import {observer} from 'mobx-react-lite';
import {useStores} from '../../store';
import {InteractiveDataTable} from '../../shared/interactive-data-table/interactive-data-table';
import {useIpListColumns} from './ip-list-columns-config';
import {useIpListCrudConfig} from './ip-list-crud-config';
import {EmptyState} from '../../shared/empty-state/empty-state';
import {IconType} from '../../shared/custom-icon/custom-icon';
import {MAX_BRONZE_IP_ADDRESSES} from '@src/utils/constants';
import './ip-list.scss';
import {ApplyBronzeButton} from '../apply-bronze-button';
import {BronzeTabName} from '@src/dtos/analytics.dto';

export const IpList = observer(() => {
    const { fwVersionBronzeStore } = useStores();
    const { getAddresses, selectedFwVersion, isLoading } = fwVersionBronzeStore;

    return <div className="ip-list" data-testid="ip-list">
        <InteractiveDataTable data={getAddresses}
                              columnsConfig={useIpListColumns()}
                              crudConfig={useIpListCrudConfig()}
                              subTitle={`Add up to ${MAX_BRONZE_IP_ADDRESSES} IP addresses`}
                              emptyStateComp={<EmptyState
                                  iconType={IconType.NoResult}
                                  subTitle="To add new item click"
                                  secondarySubTitle="Add IP Address"
                              />}
                              dataHasLoaded={!!selectedFwVersion}
                              isLoading={isLoading}
                              defaultSortColumn={'value'}>
            <ApplyBronzeButton standardApplyType={BronzeTabName.IP_EXCEPTIONS}/>
        </InteractiveDataTable>
    </div>;
});